import { Controller } from '@hotwired/stimulus';
import * as bootstrap from 'bootstrap';

export default class extends Controller {
  connect() {
    const el = this.element.querySelector('.offcanvas');
    if (!el) return;

    this.offcanvas = new bootstrap.Offcanvas(el);
    this.offcanvas.show();

    el.addEventListener('hidden.bs.offcanvas', () => {
      this.offcanvas.dispose();
      this.offcanvas = null;
      this.element.remove();

      // Clean invested param from URL
      const url = new URL(window.location.href);
      url.searchParams.delete('invested');
      history.replaceState({}, '', url.toString());
    }, {once: true});
  }
}
